import { useProductContext } from "../../context/ProductContext";
import { useCartContext } from "../../context/CartContext";
import SingleProduct from "../../components/SingleProduct";

const Product = () => {
  const { products, isLoading } = useProductContext();
  const { addToCart, addToOrder } = useCartContext();

  return (
    <>
      <section id="product1" className="section-p1">
        <h2 style={{ textAlign: "center", fontWeight: "bold" }}>PRODUCTS</h2>

        <div className="pro-container">
          {isLoading ? (
            <h5>Loading......</h5>
          ) : (
            products.map((item, index) => {
              return (
                <SingleProduct
                  key={index}
                  item={item}
                  addToCart={addToCart}
                  addToOrder={addToOrder}
                />
              );
            })
          )}
        </div>
      </section>
    </>
  );
};

export default Product;
